import {
  getEmbeddedDashboardUrl,
  updateEmbeddedDashboardUrl,
} from "../config/Config";
import { deleteRequest, postRequest, putRequest } from "./ServiceHelper";

export class EmbeddedDashboardService {
  static createEmbeddedDashboard = (embeddedDash) => {
    return postRequest(getEmbeddedDashboardUrl(), embeddedDash);
  };

  static updateEmbeddedDashboard = (embeddedDash) => {
    const dashId = embeddedDash.embeddedDatalink.id
      ? embeddedDash.embeddedDatalink.id
      : embeddedDash.embeddedDatalink.ddl_id;
    return putRequest(updateEmbeddedDashboardUrl(dashId), embeddedDash);
  };

  static deleteEmbeddedDashboard = (dashId) => {
    return deleteRequest(updateEmbeddedDashboardUrl(dashId));
  };
}
